export default "__VITE_ASSET__sdpnPuhA__"